export default {
  applyInfoPage: '/yangtse/exam/registration/info/page',
  applyPageDelete: '/yangtse/exam/registration/info/delete',
  applyPageExport: '/yangtse/exam/registration/info/export',
  applyModelDownLoad: '/yangtse/exam/registration/info/template/download',
  applyUserFileImport: '/yangtse/exam/registration/info/file/import',
  applyUserAppendixImport: '/yangtse/exam/registration/info/appendix/import',
  applyInfoQuery: '/yangtse/exam/registration/info/query',
  applyInfoEdit: '/yangtse/exam/registration/info/edit',
  applyInfoAdd: '/yangtse/exam/registration/info/add',
  jobAdd: '/yangtse/exam/registration/info/add/job',
  downLoadFile: '/yangtse/exam/registration/info/appendix/download',
  cardImport: '/yangtse/handle/pdf/upload',
  cardImportHistory: '/yangtse/handle/pdf/history',
  cardHistoryDelete: '/yangtse/handle/pdf/delete',
  cardListPage: '/yangtse/handle/pdf/ticket/manage',
  cardListDelete: '/yangtse/handle/pdf/delete/user',
  cardUploadSingle: '/yangtse/handle/pdf/upload/single',
  cardInfoQueryFn: '/yangtse/handle/pdf/query/id',
  materialsList: '/yangtse/certificate/registration/check/page',
  materialsFinishList: '/yangtse/certificate/registration/check/finish/page',
  materialsListExport: '/yangtse/certificate/registration/check/export',
  materialsFinishListExport: '/yangtse/certificate/registration/check/finish/export',
  batchCheck: '/yangtse/certificate/registration/batch/check',
  batchDeleteList: '/yangtse/certificate/registration/batch/remove',
  materialsInfoQuery: '/yangtse/certificate/registration/detail',
  materialsInfoEdit: '/yangtse/certificate/registration/edit',
  materialsCheck: '/yangtse/certificate/registration/check',
  materialsUserId: '/yangtse/certificate/registration/user/id',
  applyEducationFilter: '/yangtse/exam/registration/info/education/dropdown',
  certificateMajor: '/yangtse/certificate/registration/major',
  workJudge: '/yangtse/certificate/registration/certificate/judge',
  infoUpdate: '/yangtse/exam/registration/info/state/update',
}
